import {
  grayColor,
  whiteColor,
  hexToRgb,
} from 'assets/jss/material-dashboard-pro-react';

const getExternalTooltipHtml = ({ title, color, content }) => {
  let innerContent = '';

  content.forEach(({ hasLineBefore = false, highlightedText, text }, index) => {
    let row = '';

    if (hasLineBefore) {
      innerContent += `<hr style="height: 1px; margin: 0; background-color: ${grayColor[1]}; border: none;" />`;
    }

    if (highlightedText !== undefined) {
      row += `
        <span style="display: inline-block; margin-right: 6px; padding: 3px; text-align: center; background-color: rgba(${hexToRgb(
          whiteColor
        )}, 0.1); border-radius: 6px;">
          ${highlightedText}
        </span>`;
    }

    row += text;

    innerContent +=
      index === content.length - 1
        ? `<div style="margin-bottom: 3px;">${row}</div>`
        : `<div>${row}</div>`;
  });

  return `
  <div style="display: flex; padding: 12px 27px 12px 12px; border-radius: 6px; background-color: ${grayColor[18]}; color: ${whiteColor};">
    <div style="width: 3px; margin-right: 15px; background-color: ${color}; border-radius: 10px;"></div>
    <div style="display: flex; flex-direction: column; row-gap: 10px; font-weight: 400;">
      <div style="font-size: 14px;">${title}</div>
      ${innerContent}
    </div>
  </div>`;
};

export default getExternalTooltipHtml;
